import axios from 'axios';

const TMDB_API_KEY = '0c867cfbfa47cf1e70b33a5eac501d4a';
const TMDB_BASE_URL = 'https://api.themoviedb.org/3';

const buscarContenido = async (query) => {
  const res = await axios.get(`${TMDB_BASE_URL}/search/multi`, {
    params: {
      api_key: TMDB_API_KEY,
      language: 'es-ES',
      query
    }
  });
  return res.data.results;
};

const obtenerDetallesSerie = async (id) => {
  const res = await axios.get(`${TMDB_BASE_URL}/tv/${id}`, {
    params: {
      api_key: TMDB_API_KEY,
      language: 'es-ES'
    }
  });
  return res.data;
};

const obtenerDetallesPelicula = async (id) => {
  const res = await axios.get(`${TMDB_BASE_URL}/movie/${id}`, {
    params: {
      api_key: TMDB_API_KEY,
      language: 'es-ES'
    }
  });
  return res.data;
};

const obtenerDetallesCompleto = async (id, tipo = 'pelicula') => {
  const tipoReal = tipo === 'serie' ? 'tv' : 'movie';

  const [info, credits] = await Promise.all([
    axios.get(`${TMDB_BASE_URL}/${tipoReal}/${id}`, {
      params: {
        api_key: TMDB_API_KEY,
        language: 'es-ES'
      }
    }),
    axios.get(`${TMDB_BASE_URL}/${tipoReal}/${id}/credits`, {
      params: {
        api_key: TMDB_API_KEY,
        language: 'es-ES'
      }
    })
  ]);

  return {
    ...info.data,
    credits: credits.data
  };
};

export default {
  buscarContenido,
  obtenerDetallesSerie,
  obtenerDetallesPelicula,
  obtenerDetallesCompleto
};
